export const CONTEXTS: string[] = ['h', 'f']

export const PRISMIC_CONTEXT: { [key: string]: string } = {
  h: 'Homme',
  f: 'Femme',
}

export const BLOCK_PRODUCT_LIST: string[] = ['galleryOfProductsAndLinksBlock']

export enum CURRENCY {
  EUR = 'EUR',
  USD = 'USD',
}

export enum ACCOUNT_STATUS {
  GUEST_ACCOUNT = 'DISABLED',
  NO_ACCOUNT = 'NOT_FOUND',
  HAS_ACCOUNT = 'ENABLED',
}

export enum ORIGIN {
  HOME = 'home',
  ESHOP = 'eshop',
  STOCK = 'stock',
  AGENDA = 'agenda',
  AGENDA_TIMELINE = 'agenda-timeline',
  ARTICLE = 'article',
  PRODUCT = 'product',
  PRODUCT_TEASING = 'product-teasing',
  PAGE = 'page',
  BLOG = 'blog',
  FOOTER = 'footer',
  UNSUBSCRIBE = 'unsubscribe',
  MY_ORDERS = 'my-orders',
  SURVEY = 'survey',
  MODAL = 'modal',
  ACCOUNT = 'account',
}

export enum IMPACTS {
  CARBON = 'Carbone',
  WATER = 'Eau',
  ENERGY = 'Energie',
  PHOSPHATE = 'Phosphate',
}

// Ces structures doivent être iso avec celle renseignée côté prismic

/*
 * PRISMIC
 * Custom_type : Product
 * Emplacement : Slice Module
 * Name : status
 */
export enum STATUS {
  PRECOMMANDE = 'precommande',
  AGENDA = 'agenda',
  TEASING = 'teasing',
  STOCK = 'stock',
}

/*
 * PRISMIC
 * Custom_type : Product
 * Emplacement : Primary
 * Name : product_type
 */
export enum TYPES {
  NORMAL = 'normal',
  GIFTCARD = 'gift_card',
  ETERNEL = 'eternel',
  SAISONNIER = 'saisonnier',
  CHAMPION = 'champion',
}

/*
 * PRISMIC
 * Custom_type : Product
 * Emplacement : Primary
 * Name : market_product_type
 */
export enum MARKET_TYPES {
  NORMAL = 'normal',
  ETERNEL = 'eternel',
}

export enum MARKET_ARGUMENT {
  AUTOMATIQUE = 'auto',
  TEXTE = 'text',
}

export enum MARKET_ARGUMENT_TAG {
  AUTOMATIQUE = 'auto',
  NEW = 'new',
  TEASING = 'teasing',
  TIMER = 'timer',
  NUMBER = 'number',
  LASTCHANCE = 'last_chance',
  COCREATION = 'co_creation',
  NEWCOLOR = 'new_color',
}

export enum COLLECTION_PRODUCT_TYPES {
  NORMAL = 'normal',
  FULL = 'pleine-page',
  SLIDER = 'slider',
  GRID = 'grid',
  REF_CO = 'ref/co',
}

export enum IMAGE_FORMAT {
  PORTRAIT = 'portrait',
  SQUARE = 'carre',
  LANDSCAPE = 'paysage',
}

export enum TEXT_POSITION {
  LEFT = 'left',
  CENTER = 'centre',
  RIGHT = 'right',
}

export enum CONTENT_HIDDEN_LIST {
  FALSE = 'Non',
  HOME = 'Accueil',
  ESHOP = 'Eshop',
  ALL = 'Partout',
}

export enum DISPLAY_OPTION {
  DEFAULT = 'default',
  OVERRIDE_IMAGE = 'override_image',
  VIDEO = 'video',
}

/*
 * PRISMIC
 * Custom_type : Page
 * Emplacement : Slice Background Content
 * Name : klaviyo_form
 */
export enum FORMS {
  NONE = 'Pas de formulaire',
  DEFAULT = 'Newsletter Homme/Femme',
  KLAVIYO_LIST = 'Email pour une liste spécifique',
}
// END PRISMIC

/*
 * COOKIES
 */
export const COOKIE_EMAIL_KEY = 'asphalte-email'
export const COOKIE_BIS_KEY = 'asphalte-bis'
export const COOKIE_VISITOR_ID_KEY = 'asphalte-visitor-id'
export const COOKIE_POSTHOG_SESSION_ID_KEY = 'asphalte-ph-session-id'

/*
 * LOCALE STORAGE
 */
export const LS_ACCESS_TOKEN = 'asphalte-access-token'
export const LS_TOKEN_EXP_DATE = 'asphalte-token-exp-date'
export const LS_CART_ID = 'asphalte-cart-id'
export const LS_ORDER = 'asphalte-order'
export const LS_ORDER_SHIPPING = 'asphalte-order-shipping'
export const LS_ORDER_STATUS = 'asphalte-order-status'
export const LS_NETLIFY_DEPLOY_ID = 'asphalte-netlify-deploy-id'
export const LS_PRODUCT = 'asphalte-products'
export const LS_ORDERED_PRODUCTS = 'asphalte-ordered-products'
export const LS_PRODUCT_CONFIG = 'asphalte-product-config'
export const LS_UNLOCK_COLLECTIONS = 'asphalte-unlocked-collections'

/*
 * SESSION STORAGE
 */
export const SS_UTMS = 'asphalte-utms'
export const SS_SOURCES = 'asphalte-sources'
export const SS_UPSELLS_ITEMS = 'asphalte-upsells-items'

/**
 * TRANSITIONS
 */
export enum TRANSITIONTYPE {
  left,
  right,
  filter,
}

/**
 * SHOPIFY TYPES
 */
export enum SHOPIFY_TYPES {
  COLLECTION = 'Collection',
  PRODUCT = 'Product',
  VARIANT = 'ProductVariant',
}

/**
 * DISPLAY LIST
 */
export enum DISPLAY {
  ONE = 'one',
  TWO = 'two',
  THREE = 'three',
}

/**
 * ERRORS TYPE
 */
export enum ERRORS_TYPE {
  NONE,
  EMPTY = 'empty',
  FAIL = 'fail',
}

/**
 * UPSELLING
 */
export enum UPSELLING_TYPES {
  LINK = 'link',
  PRODUCTS = 'products',
}

export const BUNNY_STREAM_FOLDERS = {
  Snacks: '195961',
  'Article & Vidéo': '199701',
  snacks: '195961',
  'article-video': '199701',
}

export interface IUpsellingProduct {
  id: number
  slug: {
    fr?: string
    en?: string
    de?: string
  }
}

export interface IUpsellingGroupLink {
  type: UPSELLING_TYPES
  origins: number[]
  weight: number
  target: IUpsellingProduct
  context: string
  canCompleteList: boolean
  tag: {
    fr?: string
    en?: string
    de?: string
  }
}

export interface IUpsellingGroupProducts {
  type: UPSELLING_TYPES
  name: string
  weight: number
  canCompleteList: boolean
  context: string
  products: IUpsellingProduct[]
  tag: {
    fr?: string
    en?: string
    de?: string
  }
}

export type upsellingGroup = IUpsellingGroupProducts | IUpsellingGroupLink

export const UPSELLING_LIMIT = process.env.UPSELLING_MAX_ITEMS
  ? parseInt(process.env.UPSELLING_MAX_ITEMS)
  : 4

export const UPSELLING_TRADS = [
  'Les éternels',
  'Cluster',
  'La housse de costume',
]

export const COUNTRIES: { [key: string]: string } = {
  'Europe/Paris': 'fr',
  'Europe/London': 'uk',
  'Europe/Berlin': 'de',
  'Europe/Vienna': 'at',
  'Europe/Madrid': 'es',
  'Europe/Rome': 'it',
  'Europe/Brussels': 'be',
  'Europe/Zurich': 'ch',
  'Europe/Amsterdam': 'nl',
  'Europe/Luxembourg': 'lu',
  'Europe/Lisbon Portugal WET': 'ie',
}

export const PAYMENTS_BY_COUNTRIES = {
  fr: ['stripe', 'paypal', 'alma'],
  be: ['stripe', 'paypal', 'alma', 'bancontact'],
  ch: ['stripe', 'paypal', 'alma'],
  nl: ['stripe', 'paypal', 'alma', 'ideal'],
  de: ['stripe', 'paypal', 'alma'],
  at: ['stripe', 'paypal', 'alma'],
  es: ['stripe', 'paypal', 'alma'],
  it: ['stripe', 'paypal', 'alma'],
  pt: ['stripe', 'paypal', 'alma'],
  lu: ['stripe', 'paypal', 'alma'],
  ie: ['stripe', 'paypal', 'alma'],
}
